// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1bmW1","info":"UpdateTermsInfo_info__3_ybb"};